import DialogMobileView from './mobile/Dialog.mobile.view';
import DialogDesktopView from './desktop/Dialog.desktop.view';
import type DialogProperties from './Dialog.properties.ts';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import { useIsMobileDevice } from '../../tools/hooks/useIsMobileDevice.ts';

export default function DialogView(props: DialogProperties) {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <DialogMobileView {...props}>{props.children}</DialogMobileView>}
      {isDesktop && <DialogDesktopView {...props}>{props.children}</DialogDesktopView>}
    </>
  );
}
